import styled from 'styled-components';

import { GridContainer } from '@xing-com/grid';
import { SingleSizeIllustrationHeroHello } from '@xing-com/illustrations';
import { mediaSmallOrTiny } from '@xing-com/layout-tokens';
import {
  scale100,
  scale300,
  scale330,
  space4XL,
  spaceXL,
  spaceL,
  xdlColorBackgroundTertiary,
} from '@xing-com/tokens';
import { BodyCopy } from '@xing-com/typography';

const Banner = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${xdlColorBackgroundTertiary};
  padding: ${space4XL} ${scale100};

  /* necessary to be wider than what grid allows */
  max-width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
`;

const HelloIllustration = styled(SingleSizeIllustrationHeroHello)`
  width: ${scale330};
  margin-bottom: ${spaceXL};

  @media ${mediaSmallOrTiny} {
    width: ${scale300};
  }
`;

const StyledGridContainer = styled(GridContainer)`
  text-align: center;
`;

const StyledBodyCopy = styled(BodyCopy)`
  margin: ${spaceL} 0 ${spaceXL};
`;

export const Styled = {
  Banner,
  HelloIllustration,
  GridContainer: StyledGridContainer,
  BodyCopy: StyledBodyCopy,
};
